import script from "./leads-reason.vue?vue&type=script&setup=true&lang=js"
export * from "./leads-reason.vue?vue&type=script&setup=true&lang=js"

import "./leads-reason.vue?vue&type=style&index=0&id=075a095e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-075a095e"]])

export default __exports__